import { RouteObject } from 'react-router-dom';
import { ROUTE_ORGANIZATIONAL_STRUCTURE } from '../../../common/constants';
import { OrganizationalStructurePage } from '../../../pages/admin/organizational-structure-page';

export const organizationalRoutes: RouteObject = {
  path: ROUTE_ORGANIZATIONAL_STRUCTURE,
  element: <OrganizationalStructurePage />,
};
